import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
  import { useHead } from "@unhead/vue";
  import Navbar from "@/components/navigation/Navbar.vue";
  import Footer from "@/components/navigation/Footer.vue";
  import router from "./router";
  import { setMetaData } from "@/utils/functions";
  // import { useApolloClient } from '@vue/apollo-composable';

  // const { resolveClient } = useApolloClient();
  // const ApolloClient = resolveClient();

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  useHead({
    titleTemplate: (titleChunk) => {
      return titleFormat(titleChunk);
    },
    meta: [
      { name: "theme-color", content: "#ffffff" },
      { name: "msapplication-TileColor", content: "#000000" },
      // { name: "robots", content: "", key: "robots-tag" }
    ],
  })

  // onMounted(() => {
  //   getMetaData(router.currentRoute.value.path);
  // })

  // router.afterEach((to, from) => {
  //   if (from.path !== to.path) {
  //     getMetaData(to.path);
  //   }
  // })

  // function getMetaData (path: string) {
  //   setMetaData(path == "/" ? "home" : path, ApolloClient);
  // }

  function titleFormat (titleChunk: any) {
    const prependString = router.currentRoute.value.path == "/" ? "" : " | Lubanzi Inala";
    return titleChunk ? titleChunk + prependString : "Lubanzi Inala";
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, { class: "shadow-sm" }),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})